import * as types from '../common/types'
import createReducer from './createReducer'
import { uniqBy, omit } from 'lodash'

const initialState = {
  requests: {},
}

export const data = createReducer(initialState, {
  [types.SET_LOADED_LISTS](state, { overwrite = true, lists }) {
    const newState = { ...state }
    lists.forEach((list) => {
      if (overwrite) {
        newState[list.listId] = list.result
      } else {
        newState[list.listId] = uniqBy(
          [...list.result, ...newState[list.listId]],
          'id'
        )
      }
    })
    return newState
  },
  [types.SET_LOADED_LIST](state, { overwrite = true, listId, data }) {
    const newState = { ...state }
    if (overwrite || !newState[listId]) {
      newState[listId] = data
    } else {
      newState[listId] = uniqBy([...data, ...newState[listId]], 'id')
    }
    return newState
  },
  [types.SET_LOADED_ITEM_DETAIL](state, { listId, data }) {
    const newState = { ...state }
    newState[listId] = data
    return newState
  },
  [types.CLEAR_LISTS](state, { lists }) {
    return omit(state, lists)
  },
  [types.CLEAR_ALL_LISTS](state) {
    return {}
  },
  [types.INIT_DATA_FETCH](state, { id }) {
    return {
      ...state,
      requests: {
        ...state.requests,
        [id]: { isLoading: true },
      },
    }
  },
  [types.SET_DATA_FETCH_RESULT](state, { id, response }) {
    return {
      ...state,
      requests: {
        ...state.requests,
        [id]: {
          response: response.result || response,
          isLoading: false,
          error: null,
        },
      },
    }
  },
  [types.SET_DATA_FETCH_ERROR](state, { id, error }) {
    return {
      ...state,
      requests: {
        ...state.requests,
        [id]: {
          isLoading: false, // preserve response in case of error?
          error,
        },
      },
    }
  },
})
